/* DSL Compare-state — manage 3-slot compare with localStorage */
(function(){
  var KEY = "dsl_compare", MAX = 3;
  function get(){ try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch(e){ return []; } }
  function set(arr){ try { localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX))); } catch(e){} }
  function toggle(handle){
    var arr = get(), idx = arr.indexOf(handle);
    if (idx >= 0) arr.splice(idx, 1);
    else if (arr.length < MAX) arr.push(handle);
    set(arr);
    refresh();
    if (window.DSL_AB) window.DSL_AB.track("compare_toggle", {handle: handle, count: arr.length});
  }
  function refresh(){
    var arr = get();
    var drawer = document.getElementById("dsl-compare-drawer");
    if (drawer) {
      drawer.hidden = arr.length === 0;
      var cnt = drawer.querySelector("[data-compare-count]");
      if (cnt) cnt.textContent = arr.length;
    }
    var ui = document.querySelector("[data-compare]");
    if (ui && arr.length > 0) ui.hidden = false;
    document.querySelectorAll("[data-compare-toggle-btn]").forEach(function(b){
      b.setAttribute("aria-pressed", arr.indexOf(b.dataset.compareToggleBtn) >= 0 ? "true" : "false");
    });
    // Update compare-ui table
    arr.forEach(function(h, i){
      fetch("/products/" + h + ".js").then(function(r){return r.json();}).then(function(p){
        var slot = document.querySelector("[data-compare-slot=\"" + (i+1) + "\"]");
        if (slot) slot.textContent = p.title;
        var price = document.querySelector("[data-compare-price=\"" + (i+1) + "\"]");
        if (price) price.textContent = "€" + (p.price/100).toFixed(2).replace(".",",");
        var type = document.querySelector("[data-compare-type=\"" + (i+1) + "\"]");
        if (type) type.textContent = p.type;
        var brand = document.querySelector("[data-compare-brand=\"" + (i+1) + "\"]");
        if (brand) brand.textContent = p.vendor;
      }).catch(function(){});
    });
  }
  document.addEventListener("click", function(e){
    var b = e.target.closest("[data-compare-toggle-btn]");
    if (b) { e.preventDefault(); toggle(b.dataset.compareToggleBtn); }
  });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", refresh);
  else refresh();
  window.DSL_COMPARE = {get: get, toggle: toggle, refresh: refresh};
})();